import { useGetCompanyAndUserInfoQuery } from 'common/queries';
import { Button, InfiniteList } from 'components';
import { getTableResultData } from 'helpers/queriesHelper';
import { defaultMaterialTableQuery } from 'helpers/tableHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { Material, MaterialTableQuery, SelectedMaterialItem } from 'pages/material/models';
import { useGetMaterialInfiniteQuery } from 'pages/material/queries';
import React, { useEffect, useState } from 'react';

import MaterialListItem from '../MaterialListItem';

interface Props {
  searchPhrase?: string;
  selectedMaterial: SelectedMaterialItem[];
  setMaterialAmount: (item: Material, amount?: number | null) => void;
}

const MaterialList: React.FC<Props> = (props): React.ReactElement => {
  const { searchPhrase, selectedMaterial, setMaterialAmount } = props;

  const { t } = useCustomTranslation();

  const [queryParams, setQueryParams] = useState<MaterialTableQuery>({
    ...defaultMaterialTableQuery,
    searchPhrase: searchPhrase || undefined
  });

  useEffect(() => {
    searchPhrase !== undefined && setQueryParams({ ...queryParams, searchPhrase });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPhrase]);

  const materialQuery = useGetMaterialInfiniteQuery(queryParams);
  const companyAndInfoQuery = useGetCompanyAndUserInfoQuery();

  const currencyId = companyAndInfoQuery.data?.company.currencyId || 'CZK';

  const materialData = getTableResultData(materialQuery.data);

  return (
    <div className="MaterialList">
      <div className="MaterialList_head">{t('stores.availableMaterial')}</div>
      <InfiniteList
        data={materialData}
        fetchNextPage={materialQuery.fetchNextPage}
        isFetchingNextPage={materialQuery.isFetchingNextPage}
        isLoading={materialQuery.isLoading}
        renderItem={(item) => {
          const selected = selectedMaterial.find((x) => x.materialId === item.id);

          const isAllSelected = (selected && selected?.amount === undefined) || false;

          return (
            <MaterialListItem
              key={item.id}
              amount={selected?.amount || 0}
              categoryName={item.categoryName}
              supplierName={item.supplierName}
              description={item.description}
              identificationNumber={item.identificationNumber}
              maxAmount={Infinity}
              name={item.name}
              onAmountChange={(amount) => setMaterialAmount(item, amount)}
              price={item.price || 0}
              supplierCode={item.supplierCode}
              unit={item.unit}
              extraButton={
                <Button
                  onClick={() =>
                    isAllSelected ? setMaterialAmount(item, 0) : setMaterialAmount(item, undefined)
                  }
                >
                  {isAllSelected ? t('stores.unloaded') : t('stores.unlimitedAmountLabel')}
                </Button>
              }
              currencyId={currencyId}
              isAllSelected={isAllSelected}
              hideStored
            />
          );
        }}
      />
    </div>
  );
};

export default MaterialList;
